import axios from "axios";
import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { React } from "react";
import "../Style.css";
import Header from "./Header";
import Sidebar from "./Sidebar";
import parse from "html-react-parser";
import Footer from "./Footer";
import { toast } from "react-toastify";
import { fetchBusinessList } from "../services/apiService";

const CompanyDetailView = () => {
  const { id } = useParams();
  const [companyDetail, setCompanyDetail] = useState({});
  const [homePage, setHomePage] = useState("NA");
  const [aboutUsPage, setAboutUsPage] = useState("NA");
  const [contactUsPage, setContactUsPage] = useState("NA");

  const getRecords = async () => {
    try {
      const res = await fetchBusinessList("api/v1/view?id=" + id);
      if (res.success) {
        let result = res.data;
        setCompanyDetail(result);

        let homePageContent =
          result?.homePageContent != undefined ? result.homePageContent : "NA";
        setHomePage(homePageContent);

        let aboutUsPageContent =
          result?.aboutUsPageContent != undefined
            ? result.aboutUsPageContent
            : "NA";
        setAboutUsPage(aboutUsPageContent);

        let contactUsPageContent =
          result?.reachToUs != undefined ? result.reachToUs : "NA";
        setContactUsPage(contactUsPageContent);
      } else if (!res.success) {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error("Failed to load data", error);
    }
  };

  useEffect(() => {
    getRecords();
  }, []);

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className="row">
          <Sidebar />
          <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3">
              <div>
                {companyDetail.logo != "" ? (
                  <img
                    className="logo"
                    src={companyDetail.logo}
                    alt={companyDetail.websiteName}
                  />
                ) : (
                  <div className="textLogo">{companyDetail.websiteName}</div>
                )}
              </div>
              <Link
                to={`/company-detail-update/${companyDetail.id}`}
                className="btn btn-info card-link"
              >
                Update
              </Link>
            </div>

            <div className="table-responsive small">
              {companyDetail != null && (
                <table className="table table-striped ">
                  <tbody>
                    <tr>
                      <td className="font-weight-bold">Company Name</td>
                      <td>{companyDetail.websiteName}</td>
                    </tr>
                    {/* <tr>
                      <td className="font-weight-bold">Language</td>
                      <td>{companyDetail.language}</td>
                    </tr> */}
                    <tr>
                      <td className="font-weight-bold">Contact Person Name</td>
                      <td>{companyDetail.contactName}</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Contact Number</td>
                      <td>{companyDetail.contactNumber}</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Email</td>
                      <td>{companyDetail.emailId}</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Pages</td>
                      <td>
                        {companyDetail?.webPages &&
                        companyDetail.webPages.length > 0
                          ? companyDetail.webPages.toString()
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Home Page </td>
                      <td>{parse(homePage)}</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">About Us Page</td>
                      <td>{parse(aboutUsPage)}</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Reach To Us </td>
                      <td>{parse(contactUsPage)}</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Offering Type</td>
                      <td>
                        {companyDetail.offering == "both"
                          ? "Products/Services"
                          : companyDetail.offering}{" "}
                      </td>
                    </tr>
                    {companyDetail?.products &&
                      companyDetail.products.length > 0 && (
                        <tr>
                          <td colSpan="2">
                            <div className="card">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Products List</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {companyDetail?.products.map(
                                    (item, index) => (
                                      <>
                                        <tr
                                          key={index}
                                          style={{ textAlign: "center" }}
                                        >
                                          <td>
                                            <h6>
                                              {++index}. {item.name}
                                            </h6>
                                            {item.image === "" ? (
                                              <img
                                                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOOvKfUx_ihZTPIfobQQWFT_nQUrFj1ZnXzQ&usqp=CAU"
                                                height="80px"
                                                width="80px"
                                              ></img>
                                            ) : (
                                              <img
                                                src={item.image}
                                                alt={item.name}
                                                style={{
                                                  maxWidth: "100%",
                                                  maxHeight: "100px",
                                                  display: "block",
                                                }}
                                              />
                                            )}
                                          </td>
                                        </tr>
                                        <tr key={index + `2`}>
                                          <td>
                                            <span>{item.desc}</span>
                                          </td>
                                        </tr>
                                      </>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      )}

                    {companyDetail?.services &&
                      companyDetail.services.length > 0 && (
                        <tr>
                          <td colSpan="2">
                            <div className="card">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Services List</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {companyDetail?.services.map(
                                    (item, index) => (
                                      <>
                                        <tr
                                          key={index}
                                          style={{ textAlign: "center" }}
                                        >
                                          <td>
                                            <h6>
                                              {++index}. {item.name}
                                            </h6>
                                            {item.image === "" ? (
                                              <img
                                                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOOvKfUx_ihZTPIfobQQWFT_nQUrFj1ZnXzQ&usqp=CAU"
                                                height="80px"
                                                width="80px"
                                              ></img>
                                            ) : (
                                              <img
                                                src={item.image}
                                                alt={item.name}
                                                style={{
                                                  maxWidth: "100%",
                                                  maxHeight: "100px",
                                                  display: "block",
                                                }}
                                              />
                                            )}
                                          </td>
                                        </tr>
                                        <tr key={index + `1`}>
                                          <td>{item.desc}</td>
                                        </tr>
                                      </>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      )}
                  </tbody>
                </table>
              )}
            </div>
          </main>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default CompanyDetailView;
